import { Component } from '@angular/core';

import { PcBasedSimulatorComponent } from '../../../../common/pc-based-simulator/pc-based-simulator.component';
import { SimulatorConfig } from '../../../../core/models/simulation.model';
import { SimulatorType } from '../../../../core/enums/simulator-type.enum';

@Component({
  selector: 'app-upscaling-saturation-exponent',
  imports: [PcBasedSimulatorComponent],
  templateUrl: './saturation-exponent.component.html',
  styleUrl: './saturation-exponent.component.scss',
  standalone: true,
})
export class UpscalingSaturationExponentComponent {
  readonly config: SimulatorConfig = {
    title: 'Upscaling - Saturation Exponent Simulation',
    simulatorType: SimulatorType.UpscalingN,
  };
}
